import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ActivityEntityName, Entity } from '@jms/model';
import { EntityDataServiceRaw } from '@workbuddy/services/entities';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { injectDialogRef } from '@workbuddy/ui/v2/blocks/dialog';
import { outlineMoveToLineDialogBridgeStyles, outlineMoveToLineDialogStyleId } from './outline.move.to.line.dialog.theme';

@Component({
  selector: 'service-plan-outline-move-to-line-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './outline.move.to.line.dialog.html',
  styleUrls: ['./outline.move.to.line.dialog.less'],
})
export class OutlineMoveToLineDialogComponent {

  private readonly document = inject(DOCUMENT);
  private readonly entityData = inject(EntityDataServiceRaw);
  private readonly dialogRef = injectDialogRef<string>();

  /** The line entity to list — a live Service Line, or its template twin. Both outlines open this one picker. */
  public readonly $entity = input<ActivityEntityName>(ActivityEntityName.ServiceLine, { alias: 'entity' });
  public readonly $parentId = input.required<string>({ alias: 'parentId' });
  public readonly $excludeIds = input<string[]>([], { alias: 'excludeIds' });

  private readonly lines = rxResource({
    params: () => ({ parentId: this.$parentId() || undefined, entity: this.$entity() }),
    stream: ({ params }) => {

      const excludeIds = this.$excludeIds();
      return this.entityData.getPicker(params.entity, { parentId: params.parentId, excludeIds: excludeIds.length ? excludeIds : undefined }).pipe(map(response => response.items ?? []));
    },
  });

  protected readonly $lines = computed<Entity[]>(() => this.lines.value() ?? []);
  protected readonly $loading = computed(() => this.lines.isLoading());
  protected readonly $empty = computed(() => this.lines.hasValue() && this.$lines().length === 0);

  public constructor() {

    DesignSystem.Mount(this.document, outlineMoveToLineDialogStyleId, outlineMoveToLineDialogBridgeStyles);
  }

  protected pick(id: string): void {

    this.dialogRef.close(id);
  }
}
